<script>
import Layout from '@layouts/main'
import ProjectsList from '@/src/components/HMDA/ProjectsList.vue'
import { hmdaLevels } from '@utils/accesslevels'
import HmdaHeader from '@/src/components/HMDA/HmdaHeader.vue'

export default {
  components: { Layout, ProjectsList, HmdaHeader },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'HMDA',
          to: { path: '/hmda' },
        },
        { text: 'Projects', active: true },
      ],
    }
  },

  mounted() {
    hmdaLevels.initializeAccessControls()
    if (!hmdaLevels.canViewProjectsList()) {
      return this.$router.push({ name: 'home' })
    }
  },
}
</script>

<template>
  <Layout>
    <HmdaHeader :crumbs="breadcrumbs" />
    <div class="body--wrapper mt-1 bg-white container">
      <ProjectsList />
    </div>
  </Layout>
</template>
